export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const SOCIAL_MEDIA_SERVICE_URL = process.env.REACT_APP_SOCIAL_MEDIA_SERVICE_URL || "http://localhost:3000";

// Debug log to verify build-time env injection
console.log('API_BASE_URL loaded:', API_BASE_URL);

export const API_ENDPOINTS = {
  LOGIN: "/login",
  SIGNUP: "/signup",
  VERIFY_EMAIL: "/verify-email",
  RESEND_CODE: "/resend-code",
  FORGOT_PASSWORD: "/forgot-password",
  RESET_PASSWORD: "/reset-password",
  GOOGLE_LOGIN: "/auth/google",
  CHATBOT: "/chatbot/message",
  HELP_CHATBOT: "/chatbot/help-message",
  HELP_TICKET_OPTIONS: "/chatbot/help-ticket/options",
  HELP_TICKET: "/chatbot/help-ticket",
  HELP_TICKET_EMAIL: "/chatbot/help-ticket/send-email",
  CHATBOT_IMAGE: "/chatbot/image",
  GENERATE_POSTER: "/chatbot/generate-poster",
  GALLERY_GENERATE: "/chatbot/gallery/generate",
  GALLERY_UPLOAD: "/chatbot/gallery/upload",
  GALLERY_LIST: "/chatbot/gallery",
  GALLERY_DELETE: "/chatbot/gallery",
  CHATBOT_HISTORY: "/chatbot/history",
  CHATBOT_HISTORY_LOAD: "/chatbot/history/load",
  CHATBOT_ACTION_LOG: "/chatbot/log-action",
  WEBPAGE_ANALYZER: "/web-analyzer",
  WEBPAGE_ANALYZER_HISTORY: "/web-analyzer/history",
  WEBPAGE_ANALYZER_APPROVE: "/web-analyzer",
  USER_ONBOARDING: "/user/onboarding",
  SCHEDULED_POSTS: "/scheduled-posts",
  SCHEDULED_POSTS_AI: "/scheduled-posts/ai",
  CHATBOT_LINKEDIN_CAMPAIGN: "/chatbot/linkedin/campaign",
  UGC_GENERATE: "/ugc/video",
  UGC_LIST: "/ugc/videos",
};